import { render, staticRenderFns } from "./BenefitRequestSummaryCard.vue?vue&type=template&id=7bae45c8&scoped=true"
import script from "./BenefitRequestSummaryCard.vue?vue&type=script&lang=js"
export * from "./BenefitRequestSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./BenefitRequestSummaryCard.vue?vue&type=style&index=0&id=7bae45c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bae45c8",
  null
  
)

export default component.exports